/* Keep internal navigation inside the selected draft; no effect on the published store. */
(function(){
 'use strict';
 const selected=new URL(location.href).searchParams.get('preview_theme_id');
 if(!selected||!/^\d+$/.test(selected))return;
 function apply(root){
  const links=root.querySelectorAll('a[href]');
  for(const link of links){
   const raw=link.getAttribute('href');
   if(!raw||raw.startsWith('#'))continue;
   try{
    const url=new URL(raw,location.href);
    if(url.origin!==location.origin||!/^https?:$/.test(url.protocol)||url.pathname.startsWith('/checkout')||url.pathname.startsWith('/account')||url.pathname.startsWith('/cart')||url.pathname.startsWith('/admin'))continue;
    if(url.searchParams.has('preview_theme_id'))continue;
    url.searchParams.set('preview_theme_id',selected);link.href=url.href;
   }catch(_){}
  }
 }
 const run=()=>apply(document);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
 document.addEventListener('shopify:section:load',run);
})();
